<script lang="ts">
    import PauseIcon from '@amp/web-app-components/assets/icons/play-button/non-platter/pause.svg';
    import PlayIcon from '@amp/web-app-components/assets/icons/play-button/non-platter/play.svg';
    import PlayingBars from '@amp/web-app-components/src/components/PlayingBars/PlayingBars.svelte';
    import { PLAY_STATES } from '@amp/web-app-components/src/constants';

    import type { IconState } from '@amp/web-app-components/src/components/buttons/PlayButton/constants';

    export let iconState: IconState;
    export let isWindowNotFocused: boolean = false;
    export let isRefocused: boolean = false;

    const { PLAYING, PAUSE } = PLAY_STATES;
</script>

<PlayingBars {iconState} {isWindowNotFocused} {isRefocused}>
    <svelte:fragment slot="hover-slot">
        {#if iconState === PLAYING}
            <PauseIcon
                class="playing-bars-hover-svg--pause"
                aria-hidden="true"
            />
        {/if}
        {#if iconState === PAUSE}
            <PlayIcon class="playing-bars-hover-svg--play" aria-hidden="true" />
        {/if}
    </svelte:fragment>
</PlayingBars>
